import React from 'react';
import { bonuses } from '../data/bonuses';
import { BonusArt } from './BonusArt';
export function Bonuses() {
  return <section aria-labelledby="bonuses-heading" className="w-full bg-light" data-id="element-34" data-mp="pio86ksqx080">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20" data-id="element-35" data-mp="avl8c7gyafhi">
        <div className="text-center" data-id="element-36" data-mp="at8vg8q1uvbb">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-court-deep" data-id="element-37" data-mp="ftegv75q7lky">
            Also included at no extra cost
          </p>
          <h2 id="bonuses-heading" className="mt-3 font-display font-bold text-ink text-[28px] leading-tight tracking-tight sm:text-5xl" data-id="element-38" data-mp="1whrzb964e6p">
            Five instant-use <span className="text-court-deep" data-id="element-39" data-mp="3o3g0q74jffo2">bonuses</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-ink-soft" data-id="element-40" data-mp="3t1rdapm7w49z">
            The volumes give you the year. These five get you ready for your
            very next group.
          </p>
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-41" data-mp="1r80fnyd1kw9j">
          {bonuses.map((bonus, i) => <article key={bonus.number} className={`flex flex-col overflow-hidden rounded-2xl border border-line bg-white shadow-card ${i === bonuses.length - 1 ? 'sm:col-span-2 sm:mx-auto sm:w-[calc(50%-8px)]' : ''}`} data-id="element-42" data-mp="3id54555371a9" data-mpi={i}>
              {bonus.cover ? <img src={bonus.cover} alt={`${bonus.title} cover`} width={1024} height={1024} loading="lazy" className="aspect-[4/3] w-full border-b border-line object-cover object-center" data-id="element-43" data-mp="2zfar8g0u85ml" /> : <BonusArt number={bonus.number} title={bonus.title} index={i} data-id="element-44" data-mp="33ge5iy38ltlp" />}
              <div className="px-5 pb-6 pt-4" data-id="element-45" data-mp="noq70y8krt0s">
                <div className="flex flex-wrap items-center gap-2" data-id="element-46" data-mp="iqyhgavekizr">
                  <span className="text-[11px] font-bold uppercase tracking-widest text-ink-muted" data-id="element-47" data-mp="iqop4gmvxzqw">
                    Bonus {bonus.number}
                  </span>
                  <span className="rounded bg-green-deep px-2 py-1 text-[10px] font-bold uppercase tracking-wider text-white" data-id="element-48" data-mp="3hh7yasnxdfxo">
                    Free today
                  </span>
                </div>
                <h3 className="mt-2.5 font-display text-lg font-bold leading-snug text-ink" data-id="element-49" data-mp="3qhmni340ff6g">
                  {bonus.title}
                </h3>
                <p className="mt-2 text-sm text-ink-soft" data-id="element-50" data-mp="2tqlsz95b29rd">{bonus.body}</p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}